import { create } from 'zustand';

type State = {
  path: string;
  search: string;
  setState: (path: string, search: string) => void;
};

/**
 * Store to persist navigation state when navigating between routes. This
 * replaces the previous approach of using the router's location.state to make
 * it work across browsers appropriately.
 */
export const useNavigationStore = create<State>((set) => ({
  path: '',
  search: '',
  setState: (path: string, search: string) => set({ path, search }),
}));
